import MalattieInfettiveStrutturaEditPage from "./pages/MalattieInfettiveStrutturaEditPage.vue";
import MalattieInfettiveStrutturaViewPage from "./pages/MalattieInfettiveStrutturaViewPage.vue";
import MalattieInfettiveStruttureListPage from "./pages/MalattieInfettiveStruttureListPage.vue";

export default {
    MalattieInfettiveStrutturaEditPage,
    MalattieInfettiveStrutturaViewPage,
    MalattieInfettiveStruttureListPage,
};
